export const styles = {
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "flex-start",
    gap: 0.5,
    mb: 2,
    color: "text.primary",
    fontWeight: 600,
    "&:hover": { opacity: 0.7 },
    textDecoration: "none",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: { xs: 2, sm: 3 },
  },
  titleWrapper: {
    mb: { xs: 2, sm: 0 },
  },
};
